import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";
import { Observable } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class TermsAndConditionsConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	isHistoryEnabled(): boolean {
		return this.configService.get((x) => x.common.termsAndConditions?.historyEnabled, false);
	}

	getHistoryEndpoint(): string {
		return this.configService.get(
			(x) => x.common.termsAndConditions?.endpoints?.history,
			"v1/agreements/TermsAndConditions/history"
		);
	}

	getLatestVersionEndpoint(): string {
		return this.configService.get(
			(x) => x.common.termsAndConditions?.endpoints?.latestVersion,
			"v1/agreements/latest/TermsAndConditions"
		);
	}

	isLatestAcceptedContentEnabled(): boolean {
		return this.configService.get((x) => x.common.termsAndConditions?.isLatestAcceptedContentEnabled, false);
	}

	showFullContentInDialog$(): Observable<boolean | undefined> {
		return this.configService.get$((x) => x.common.termsAndConditions?.showFullContentInDialog, false);
	}

	latestAcceptedContentUrl(): string {
		return this.configService.get(
			(x) => x.common.termsAndConditions?.endpoints?.latestAcceptedContent,
			"v1/agreements/TermsAndConditions/LatestAcceptedContent"
		);
	}
}
